export const CONTACT_CATEGORY_SETTINGS_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};
